'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _Object$create = require('@babel/runtime-corejs3/core-js-stable/object/create');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var items_data_link = require('./items.data.link.js');
var graphchart_data_node = require('./graphchart.data.node.js');
var graphchart_style = require('./graphchart.style.js');
var utils = require('./utils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _Object$create__default = /*#__PURE__*/_interopDefaultLegacy(_Object$create);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * AddLinkOption interface.
 * It is used to determine how handle the nodes and link for a added link.
 * `defaults` | `extend` | `overwrite`
 * If a node or link exists:
 * `defaults`: keep using old values for any existed field, use new values for non existed field
 * `extend`: Merge new values with old values, prefer using new values for duplicated fields.
 * `overwrite`: descard all old values. Use new values instead.
 */

/**
 * Graph chart link object.
 * @preferred
 */
var GraphChartDataLink = /*#__PURE__*/function (_ItemsDataLink) {
  /**
   * An internal link object.
   * @param {string}             internalID internalID by registerExternalLink;
   * @param {ExternalLink}       exLink     external link data object
   * @param {GraphChartDataNode} source     internal source node object
   * @param {GraphChartDataNode} target     internal target node object
   */
  function GraphChartDataLink(internalID, exLink, source, target) {
    var _this;
    _classCallCheck__default["default"](this, GraphChartDataLink);
    _this = _callSuper(this, GraphChartDataLink, [internalID, source.id, target.id]);
    /**
     * source node object;
     * @type {GraphChartDataNode}
     */
    /**
     * target node object;
     * @type {GraphChartDataNode}
     */
    /**
     * external link type
     * @type {string}
     */
    /**
     * Indicate directed or undirected type link;
     * @type {boolean}
     */
    /**
     * Style object for graph link object.
     */
    /**
     * label object to determine which label needs to be shown in visualization.
     */
    _defineProperty__default["default"](_this, "pointsX", []);
    _defineProperty__default["default"](_this, "pointsY", []);
    _defineProperty__default["default"](_this, "isLink", true);
    _this.source = source;
    _this.target = target;
    _this.exType = exLink.type;
    _this.directed = exLink.directed === undefined ? true : exLink.directed;
    _this.attrs = utils.Utils.cloneDeep(exLink.attrs) || _Object$create__default["default"](null);
    _this.styles = new graphchart_style.GraphStyle.GraphChartLinkStyles(exLink.styles);
    _this.others = utils.Utils.cloneDeep(exLink.others) || _Object$create__default["default"](null);
    _this.labels = _Object$create__default["default"](null);
    return _this;
  }

  /**
   * Merge external node. Prefer external node values.
   * @param  {ExternalNode} exNode [description]
   * @return {this}                [description]
   */
  _inherits__default["default"](GraphChartDataLink, _ItemsDataLink);
  return _createClass__default["default"](GraphChartDataLink, [{
    key: "x",
    get: function get() {
      return this.pointsX;
    }
  }, {
    key: "y",
    get: function get() {
      return this.pointsY;
    }

    /**
     * This field is used for storing middle reuslt from several algorithms which need to be shown in visualization or affect layout.
     * @type {any}
     */
  }, {
    key: "extendLink",
    value: function extendLink(exLink) {
      var newLink = utils.Utils.cloneDeep(exLink);
      for (var key in newLink.attrs) {
        if (Object.prototype.hasOwnProperty.call(newLink.attrs, key)) {
          if (newLink.attrs[key] === '') {
            delete newLink.attrs[key];
          }
        }
      }
      utils.Utils.extend(this.attrs, newLink.attrs);
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartLinkStyles(newLink.styles);
      utils.Utils.extend(this.styles, tmpStyle);
      utils.Utils.extend(this.others, newLink.others);
      utils.Utils.extend(this.labels, newLink.labels);
      if (exLink.directed === false) {
        this.directed = false;
      }
      return this;
    }

    /**
     * Merge external Link. Prefer old Link values.
     * @param  {ExternalLink} exLink [description]
     * @return {this}                [description]
     */
  }, {
    key: "defaultsLink",
    value: function defaultsLink(exLink) {
      var newLink = utils.Utils.cloneDeep(exLink);
      utils.Utils.defaultsDeep(this.attrs, newLink.attrs);
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartLinkStyles(newLink.styles);
      utils.Utils.defaultsDeep(this.styles, tmpStyle);
      utils.Utils.defaultsDeep(this.others, newLink.others);
      utils.Utils.defaultsDeep(this.labels, newLink.labels);
      if (exLink.directed === false) {
        this.directed = false;
      }
      return this;
    }

    /**
     * Assign external Link values to old Links.
     * @param  {ExternalLink} exLink [description]
     * @return {this}                [description]
     */
  }, {
    key: "overwriteLink",
    value: function overwriteLink(exLink) {
      var newLink = utils.Utils.cloneDeep(exLink);
      this.attrs = newLink.attrs;
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartLinkStyles(newLink.styles);
      this.styles = tmpStyle;
      this.others = newLink.others;
      this.labels = newLink.labels;
      if (exLink.directed === false) {
        this.directed = false;
      }
      return this;
    }
  }]);
}(items_data_link.ItemsDataLink);
function getLinkID(link) {
  var _context, _context2, _context3, _context4, _context5;
  var source = _concatInstanceProperty__default["default"](_context = "".concat(link.source.type, "#")).call(_context, link.source.id);
  var target = _concatInstanceProperty__default["default"](_context2 = "".concat(link.target.type, "#")).call(_context2, link.target.id);
  var id = _concatInstanceProperty__default["default"](_context3 = _concatInstanceProperty__default["default"](_context4 = _concatInstanceProperty__default["default"](_context5 = "".concat(link.type, "#")).call(_context5, source, "#")).call(_context4, target)).call(_context3, link.discriminator ? '#' + link.discriminator : '');
  if (!link.directed) {
    var _context6, _context7, _context8, _context9, _context10, _context11;
    id = source > target ? _concatInstanceProperty__default["default"](_context6 = _concatInstanceProperty__default["default"](_context7 = _concatInstanceProperty__default["default"](_context8 = "".concat(link.type, "#")).call(_context8, source, "#")).call(_context7, target)).call(_context6, link.discriminator ? '#' + link.discriminator : '') : _concatInstanceProperty__default["default"](_context9 = _concatInstanceProperty__default["default"](_context10 = _concatInstanceProperty__default["default"](_context11 = "".concat(link.type, "#")).call(_context11, target, "#")).call(_context10, source)).call(_context9, link.discriminator ? '#' + link.discriminator : '');
  }
  return id;
}
function createGraphChartDataLink(exLink) {
  return new GraphChartDataLink(getLinkID(exLink), exLink, graphchart_data_node.createGraphChartDataNode(exLink.source), graphchart_data_node.createGraphChartDataNode(exLink.target));
}

exports.GraphChartDataLink = GraphChartDataLink;
exports.createGraphChartDataLink = createGraphChartDataLink;
exports.getLinkID = getLinkID;
